<template>
  <v-row>
    <!-- name -->
    <v-col cols="12" md="12" class="py-0 my-0">
      <v-text-field
        label="Prénom"
        color="secondary"
        class="py-0 my-0"
        append-icon="mdi-rename-box"
        v-model="firstNameLocal"
        :error-messages="firstNameErrors"
        @input="$v.firstNameLocal.$touch()"
        @blur="$v.firstNameLocal.$touch()"
      />
    </v-col>
    <v-col cols="12" md="12" class="py-0 my-0">
      <v-text-field
        label="Nom"
        color="primary"
        class="py-0 my-0"
        append-icon="mdi-rename-box"
        v-model="lastNameLocal"
        :error-messages="lastNameErrors"
        @input="$v.lastNameLocal.$touch()"
        @blur="$v.lastNameLocal.$touch()"
      />
    </v-col>
    <!-- email -->
    <v-col cols="12" md="12" class="py-0 my-0">
      <p>{{ mailLocal }} <UpdateMailDialog /></p>
    </v-col>
    <!-- birthday -->
    <v-col cols="12" md="12" class="py-0 my-0">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            color="primary"
            v-model="birthdayLocal"
            label="Date de naissance"
            hint="MM/DD/YYYY format"
            persistent-hint
            append-icon="mdi-cake"
            v-on="on"
            class="py-0 my-0"
          ></v-text-field>
        </template>
        <v-date-picker
          class="py-0 my-0"
          v-model="birthdayLocal"
          no-title
          @input="menu = false"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <!-- phone -->
    <v-col cols="12" md="12" class="py-0 my-0">
      <v-text-field
        label="Numéro de telephone"
        color="primary"
        append-icon="mdi-phone"
        v-model="phoneLocal"
      />
    </v-col>
    <!-- gender -->
    <v-col cols="12" md="12" class="py-0 my-0" v-if="type !== 'gym'">
      <v-radio-group row v-model="genderLocal">
        <v-radio
          class="py-0 my-0"
          :ripple="false"
          label="Homme"
          value="male"
          off-icon="mdi-gender-male"
          on-icon="mdi-gender-male"
          color="blue"
        ></v-radio>
        <v-radio
          :ripple="false"
          label="Femme"
          value="female"
          off-icon="mdi-gender-female"
          on-icon="mdi-gender-female"
          color="pink"
        ></v-radio>
      </v-radio-group>
    </v-col>
  </v-row>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";
import UpdateMailDialog from "@/components/profile/UpdateMailDialog";

export default {
  mixins: [validationMixin],
  validations: {
    firstNameLocal: { required, minLength: minLength(5) },
    lastNameLocal: { required, minLength: minLength(5) },
    descriptionLocal: { minLength: minLength(10) },
    mailLocal: { required, email: email(10) },
  },
  components: { UpdateMailDialog },
  props: [
    "type",
    "firstName",
    "lastName",
    "mail",
    "phone",
    "gender",
    "birthday",
  ],
  data() {
    return {
      menu: false,
    };
  },
  methods: {
    isValide() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
  },
  computed: {
    firstNameLocal: {
      get() {
        return this.firstName;
      },
      set(value) {
        this.$emit("update:firstName", value);
      },
    },
    lastNameLocal: {
      get() {
        return this.lastName;
      },
      set(value) {
        this.$emit("update:lastName", value);
      },
    },
    mailLocal: {
      get() {
        return this.mail;
      },
      set(value) {
        this.$emit("update:mail", value);
      },
    },
    genderLocal: {
      get() {
        return this.gender;
      },
      set(value) {
        this.$emit("update:gender", value);
      },
    },
    phoneLocal: {
      get() {
        return this.phone;
      },
      set(value) {
        this.$emit("update:phone", value);
      },
    },
    birthdayLocal: {
      get() {
        return this.birthday;
      },
      set(value) {
        this.$emit("update:birthday", value);
      },
    },
    // VALIDATION ERRORS
    firstNameErrors() {
      const errors = [];
      if (!this.$v.firstNameLocal.$dirty) return errors;
      !this.$v.firstNameLocal.minLength &&
        errors.push("Ce nécissite plus de 5 caractéres");
      !this.$v.firstNameLocal.required &&
        errors.push("Ce champ est obligatoire.");
      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.lastNameLocal.$dirty) return errors;
      !this.$v.lastNameLocal.minLength &&
        errors.push("Ce nécissite plus de 5 caractéres");
      !this.$v.lastNameLocal.required &&
        errors.push("Ce champ est obligatoire.");
      return errors;
    },
    descriptionErrors() {
      const errors = [];
      if (!this.$v.descriptionLocal.$dirty) return errors;
      !this.$v.descriptionLocal.minLength &&
        errors.push("la description doit être 10 caractére au minimum.");
      return errors;
    },
    mailErrors() {
      const errors = [];
      if (!this.$v.mailLocal.$dirty) return errors;
      !this.$v.mailLocal.email && errors.push("email@exemple.com");
      return errors;
    },
  },
};
</script>

<style scoped>
.v-label {
  font-size: 12px !important;
}
.v-input input {
  font-size: 12px;
}
.v-input .v-label {
  font-size: 12px;
}
.v-text-field input {
  font-size: 12px;
}
</style>